module.exports = __webpack_public_path__ + "static/media/Gotham-Book.9019ab71.otf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/fonts/Gotham Fonts/Gotham-Book.otf
// module id = 1183
// module chunks = 0